// extracted by mini-css-extract-plugin
module.exports = {"tooltip-error":"Tooltip_tooltip-error__PHUCt","tooltip-info":"Tooltip_tooltip-info__BGsJw"};